export const REQUEST_CONTEXT_EVENT = 'request_context';

export type RequestContextPayload = {
  http_user_agent: string;
  sec_ch_ua: string;
  sec_ch_ua_mobile: string;
  sec_ch_ua_platform: string;
  cdn_bot_score: string;
  cdn_custom_bots: string;
  cdn_ai_bots: string;
  cdn_public_bots: string;
  cdn_bot_tags: string;
};

export const EMPTY_REQUEST_CONTEXT_PAYLOAD: RequestContextPayload = {
  http_user_agent: '',
  sec_ch_ua: '',
  sec_ch_ua_mobile: '',
  sec_ch_ua_platform: '',
  cdn_bot_score: '',
  cdn_custom_bots: '',
  cdn_ai_bots: '',
  cdn_public_bots: '',
  cdn_bot_tags: ''
};

export const HTTP_USER_AGENT_MAX_LENGTH = 512;
export const REQUEST_CONTEXT_FIELD_MAX_LENGTH = 256;

/**
 * CDNetworks Bot Tagging headers (DBP-4426). Missing headers become ''.
 */
export const REQUEST_CONTEXT_CDN_HEADER_MAP = {
  cdn_bot_score: ['x-cdn-bot-score'],
  cdn_custom_bots: ['x-cdn-custom-bots'],
  cdn_ai_bots: ['x-cdn-ai-bots'],
  cdn_public_bots: ['x-cdn-public-bots'],
  cdn_bot_tags: ['x-cdn-bot-tags']
} as const;
